var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "collapse",
        {
          attrs: { title: "Descripción completa de los servicios solicitados" }
        },
        [
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required: "El campo es requerido."
                  },
                  rules: "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              label:
                                "A. Explique en detalle los servicios solicitados, lo que espera para cada tarea y en caso de tener una fecha o periodo limite favor indicar cuando debe estar completada la misma. La lista debe incluir especificaciones técnicas y de ejecución.",
                              maxlength: 5000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.fullDescription,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "fullDescription", $$v)
                              },
                              expression: "model.fullDescription"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  59645195
                )
              })
            : _vm.isReadOnly
            ? _c("div", { staticClass: "my-2" }, [
                _c("div", { staticClass: "my-2" }, [
                  _vm._v(
                    " A. Explique en detalle los servicios solicitados, lo que espera para cada tarea y en caso de tener una fecha o periodo limite favor indicar cuando debe estar completada la misma. La lista debe incluir especificaciones técnicas y de ejecución. "
                  )
                ]),
                _c("label", { staticClass: "data-label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.model.fullDescription)) +
                      " "
                  )
                ])
              ])
            : _vm._e(),
          _c("div", { staticClass: "custom-font my-2" }, [
            _vm._v(
              " B. Requisitos de personal. Se espera que los empleados del contratista tengan un mínimo de cualificaciones o destrezas. Especifique si el DEPR exige alguna licencia, cualificaciones o conocimientos específicos. "
            )
          ]),
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required: "El campo es requerido."
                  },
                  rules: "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              label: "Cualificaciones o Destrezas:",
                              maxlength: 3000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.qualifications,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "qualifications", $$v)
                              },
                              expression: "model.qualifications"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4269287825
                )
              })
            : _vm.isReadOnly
            ? _c("div", { staticClass: "my-2" }, [
                _c("div", [_vm._v(" Cualificaciones o Destrezas: ")]),
                _c("label", { staticClass: "data-label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.model.qualifications)) +
                      " "
                  )
                ])
              ])
            : _vm._e(),
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required: "El campo es requerido."
                  },
                  rules: "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              label: "Licencias:",
                              maxlength: 3000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.licenses,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "licenses", $$v)
                              },
                              expression: "model.licenses"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3012831098
                )
              })
            : _vm.isReadOnly
            ? _c("div", [
                _c("div", [_vm._v(" Licencias: ")]),
                _c("label", { staticClass: "data-label" }, [
                  _vm._v(
                    " " + _vm._s(_vm._f("empty")(_vm.model.licenses)) + " "
                  )
                ])
              ])
            : _vm._e(),
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required: "El campo es requerido."
                  },
                  rules: "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              label: "Conocimientos Específicos:",
                              maxlength: 3000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.specificKnowledge,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "specificKnowledge", $$v)
                              },
                              expression: "model.specificKnowledge"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3962395816
                )
              })
            : _vm.isReadOnly
            ? _c("div", [
                _c("div", { staticClass: "my-2" }, [
                  _vm._v(" Conocimientos Específicos: ")
                ]),
                _c("label", { staticClass: "data-label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.model.specificKnowledge)) +
                      " "
                  )
                ])
              ])
            : _vm._e(),
          _c("div", { staticClass: "custom-font my-2" }, [
            _vm._v(
              " C. Equipo suministrado por el DEPR y otros recursos que deberá suministrar el contratista. Describa los equipos y recursos que el DEPR proveerá al contratista para que este brinde sus servicios. "
            )
          ]),
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ validated }) {
                  return [
                    _c("equipments", {
                      ref: "equipments",
                      attrs: { "is-read-only": _vm.isReadOnly },
                      model: {
                        value: _vm.model.equipments,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "equipments", $$v)
                        },
                        expression: "model.equipments"
                      }
                    }),
                    validated && !_vm.model.equipments.length
                      ? _c("error", {
                          attrs: {
                            message: "Debe haber al menos 1 equipo agregado.",
                            variant: "no-border"
                          }
                        })
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("div", { staticClass: "custom-font my-2" }, [
            _vm._v(
              " D. Reportes requeridos. Describa los reportes que deberá someter el contratista para demostrar su progreso "
            )
          ]),
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ validated }) {
                  return [
                    _c("reports", {
                      ref: "reports",
                      attrs: { "is-read-only": _vm.isReadOnly },
                      model: {
                        value: _vm.model.reports,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "reports", $$v)
                        },
                        expression: "model.reports"
                      }
                    }),
                    validated && !_vm.model.reports.length
                      ? _c("error", {
                          attrs: {
                            message: "Debe haber al menos 1 reporte agregado.",
                            variant: "no-border"
                          }
                        })
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }